module.exports = __webpack_public_path__ + "img/icon_search.66dee98b.png";